import { Link } from "react-router-dom";
import { BadgeCheck, Star } from "lucide-react";
import { Card, Badge } from "./ui/Card";

export default function BusinessCard({ business }) {
  const photo = business.venue_photo_urls?.[0] || business.logo_url;

  return (
    <Link to={`/${business.slug}`} state={{ source: "marketplace" }} className="group block">
      <Card className="overflow-hidden transition-shadow hover:shadow-md">
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
          {photo ? (
            <img
              src={photo}
              alt={business.name}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-4xl font-montserrat font-bold text-primary/30">
              {business.name?.[0]}
            </div>
          )}
          {business.rating_count > 0 && (
            <div className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-slate-900/80 px-2 py-1 text-xs font-semibold text-white">
              <Star className="h-3 w-3 fill-amber-400 text-amber-400" />
              {Number(business.rating_avg).toFixed(1)}
              <span className="text-white/70">({business.rating_count})</span>
            </div>
          )}
          {business.is_promoted && (
            <Badge variant="dark" className="absolute left-2 top-2">
              Promoted
            </Badge>
          )}
        </div>
        <div className="space-y-1.5 p-4">
          <h3 className="flex items-center gap-1 font-montserrat font-semibold text-slate-900">
            <span className="truncate">{business.name}</span>
            {business.is_verified && <BadgeCheck className="h-4 w-4 shrink-0 text-primary" aria-label="Verified by SHUWA" />}
          </h3>
          <p className="truncate text-sm text-muted-foreground">
            {business.city || business.address}
            {business.distance_km != null && ` · ${business.distance_km} km`}
          </p>
          <div className="flex flex-wrap gap-1.5 pt-1">
            {business.category?.name && (
              <Badge variant="default">{business.category.name}</Badge>
            )}
          </div>
        </div>
      </Card>
    </Link>
  );
}
